var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"found"},[_c('div',{staticClass:"found-message"},[_vm._v("\n    "+_vm._s(_vm.$l.cardNotFound)+"\n  ")]),_c('button-full-screen',{attrs:{"action":_vm.hide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }